/* NS PROMO - rush hint on the product-page quote form (20 Oct 2026).
   If the Required Date is sooner than 10 business days, show a short full-width note linking to Rush Orders. */
(function () {
  'use strict';
  function bizDays(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v || ''));
    if (!m) return null;
    var end = new Date(+m[1], +m[2] - 1, +m[3]), d = new Date(), n = 0;
    d.setHours(0, 0, 0, 0);
    while (d < end) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n++; }
    return n;
  }
  function place(tip, el) {
    var field = el.closest('.nsq4__field');
    if (!field) { el.insertAdjacentElement('afterend', tip); return; }
    var anchor = field, nx = field.nextElementSibling;
    if (nx && nx.offsetTop === field.offsetTop) anchor = nx;
    if (tip.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', tip);
  }
  function attach(form) {
    if (form.__nsRush) return;
    var el = Array.prototype.filter.call(form.elements, function (x) { return /required\s*date/i.test(x.name || ''); })[0];
    if (!el) return;
    form.__nsRush = true;
    var tip = document.createElement('p');
    tip.className = 'ns-rush-hint';
    tip.hidden = true;
    tip.setAttribute('aria-live', 'polite');
    tip.style.cssText = 'grid-column:1/-1;margin:-4px 0 0;font-size:13px;line-height:1.45;';
    tip.innerHTML = 'That’s sooner than our standard 7–10 business days. We can often still help: <a href="/pages/fast-turnaround" target="_blank" rel="noopener" style="text-decoration:underline">see how rush orders work</a>.';
    place(tip, el);
    function check() {
      var n = bizDays(el.value), show = n !== null && n < 10;
      if (show) place(tip, el);
      tip.hidden = !show;
    }
    el.addEventListener('change', check);
    el.addEventListener('input', check);
    check();
  }
  function scan() { document.querySelectorAll('[data-nsq4] form').forEach(attach); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true}); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
